<script module lang="ts">
  import { getContext, setContext, type Snippet } from 'svelte';
  import { type GameMode, Game } from './game.svelte';

  const gameStateKey = Symbol('game-state');
  type GameRef<G extends Game = Game> = { current: G };

  export const getGame = <G extends Game>() =>
    getContext<GameRef<G>>(gameStateKey);

  export const setGame = () => {
    const gameState = getContext<GameRef>(gameStateKey);
    return (game: Game) => {
      gameState.current = game;
    };
  };
</script>

<script lang="ts" generics="M extends GameMode">
  type Props = {
    game: Game;
    children: Snippet;
  };
  const props: Props = $props();
  // svelte-ignore state_referenced_locally
  const gameState = $state<GameRef>({ current: props.game });
  setContext<GameRef>(gameStateKey, gameState);
</script>

{#key gameState.current.id}
  {@render props.children()}
{/key}
